<template>
    <div style="height: 500px;overflow: scroll;margin-bottom:10px">
        <div class="school-info">
            <div class="school-info-icon"></div>
            <div class="school-info-title">学校基本信息</div>
        </div>
        <div>
            <div class="table-list-conten">
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-1.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                创办时间：
                            </div>
                            <div
                                class="span-two"
                                v-if="schoolInfo.basicInformationOfTheSchool"
                            >
                                {{
                                    $Common.dateFormatDate(
                                        schoolInfo
                                            .basicInformationOfTheSchool[0]
                                            .establishmentTime
                                    )
                                }}
                            </div>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-3.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                学校类别：
                            </div>
                            <div
                                class="span-two"
                                v-if="schoolInfo.basicInformationOfTheSchool"
                            >
                                {{
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .schoolTypeName
                                }}
                            </div>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-3.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                机构代码：
                            </div>
                            <div
                                class="span-two"
                                v-if="schoolInfo.basicInformationOfTheSchool"
                            >
                                {{
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .schoolInstitutionCode
                                }}
                            </div>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-4.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                办学类型：
                            </div>
                            <div
                                class="span-two"
                                v-if="schoolInfo.basicInformationOfTheSchool"
                            >
                                {{
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .workTypeName
                                }}
                            </div>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-5.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                学校地址：
                            </div>
                            <el-tooltip
                                class="item"
                                v-if="
                                        schoolInfo.basicInformationOfTheSchool
                                    "
                                effect="dark"
                                :content="
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .schoolAddress
                                "
                                placement="top"
                            >
                                <div
                                    class="span-two"
                                    
                                >
                                    {{
                                        schoolInfo
                                            .basicInformationOfTheSchool[0]
                                            .schoolAddress
                                    }}
                                </div>
                            </el-tooltip>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
                <div class="table-item">
                    <div class="item-left">
                        <img src="@/assets/img/schoolBaseInfo/school-info-icon-6.png" alt="" />
                    </div>
                    <div class="item-right">
                        <div class="item-right-top">
                            <div class="span-one">
                                校方联系方式：
                            </div>
                            <el-tooltip
                                class="item"
                                v-if="
                                        schoolInfo.basicInformationOfTheSchool
                                    "
                                effect="dark"
                                :content="
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .principalPhone
                                "
                                placement="top"
                            >
                            <div
                                class="span-two"
                                v-if="schoolInfo.basicInformationOfTheSchool"
                            >
                                {{
                                    schoolInfo.basicInformationOfTheSchool[0]
                                        .principalPhone
                                }}
                            </div>
                            </el-tooltip>
                        </div>
                        <div class="item-right-bottom"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="school-info">
            <div class="school-info-icon"></div>
            <div class="school-info-title">学校架构信息</div>
        </div>
        <div class="manage-structure">
            <div class="principal-list">
                <div
                    class="principal-list-item"
                    v-for="(item,
                    index) in schoolInfo.basicInformationOfManagementStructure"
                    :key="index"
                ><el-tooltip class="item" effect="light" :content="item.position" placement="top">
                    <span>{{ item.position }}</span></el-tooltip>
                </div>
            </div>
            <img
                v-if="
                    schoolInfo.basicInformationOfManagementStructure &&
                        schoolInfo.basicInformationOfManagementStructure
                            .length > 0
                "
                src="@/assets/img/schoolBaseInfo/principal-img.png"
                alt=""
                :height="
                    schoolInfo.basicInformationOfManagementStructure.length * 44
                "
            />
            <div v-else class="noData">
                暂无数据
            </div>
            <div class="principal-list">
                <div
                    class="principal-list-item"
                    v-for="(item,
                    index) in schoolInfo.basicInformationOfManagementStructure"
                    :key="index"
                >
                    {{ item.name }}
                </div>
            </div>
            <div class="principal-list">
                <div
                    class="principal-list-item"
                    v-for="(item,
                    index) in schoolInfo.basicInformationOfManagementStructure"
                    :key="index"
                >
                    {{ item.phone }}
                </div>
            </div>
        </div>
        <div class="school-info">
            <div class="school-info-icon"></div>
            <div class="school-info-title">学校师生信息</div>
        </div>
        <div>
            <div class="key-file-item">
                <div
                    class="key-file-item-centen"
                    v-for="(item,
                    index) in schoolInfo.numberOfSchoolTeachersAndStudents"
                    :key="index"
                >
                    <img
                        v-if="item.mark == 'teacherNum'"
                        src="@/assets/img/schoolBaseInfo/teacher-icon.png"
                        alt=""
                    />
                    <img v-else src="@/assets/img/schoolBaseInfo/student-icon.png" alt="" />
                    <div class="key-file-item-info">
                        <div class="school-number">
                            <span style="font-size:20px">
                                {{ item.num || '0' }}
                            </span>
                            名
                        </div>
                        <div
                            class="school-type"
                            v-if="item.mark == 'teacherNum'"
                        >
                            老师
                        </div>
                        <div class="school-type" v-else>学生</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="school-info">
            <div class="school-info-icon"></div>
            <div class="school-info-title">学校档案信息</div>
        </div>

        <div class="school-info-detail" v-if="numTotal > 0">
            <div class="file-num-total">
                已填报档案
                <span style="color:#FFAA2D;font-size: 14px;">{{
                    numTotal
                }}</span>
                份
            </div>
            <video-pie
                v-if="schoolInfo.numberOfFilesReported"
                :echartsData="schoolInfo.numberOfFilesReported"
                legendAlign="right"
            ></video-pie>
        </div>
        <div v-else class="noData">
            暂无数据
        </div>
        <div class="school-info">
            <div class="school-info-icon"></div>
            <div class="school-info-title">学校安防信息</div>
        </div>
        <div v-if="schoolInfo.schoolSecurityInformation">
            <div class="key-file-item">
                <div class="key-file-item-centen">
                    <img src="@/assets/img/schoolBaseInfo/monitoring-icon.png" alt="" />
                    <div class="key-file-item-info">
                        <div class="school-number">
                            <span style="font-size:20px">
                                {{
                                    schoolInfo.schoolSecurityInformation[0]
                                        .sum || '0'
                                }}
                            </span>
                            个
                        </div>
                        <div class="school-type">
                            {{
                                schoolInfo.schoolSecurityInformation[0]
                                    .equipment
                            }}
                        </div>
                    </div>
                </div>
                <div class="key-file-item-centen">
                    <img src="@/assets/img/schoolBaseInfo/equipment-icon.png" alt="" />
                    <div class="key-file-item-info">
                        <div class="school-number">
                            <span style="font-size:20px">
                                {{
                                    schoolInfo.schoolSecurityInformation[1]
                                        .sum || '0'
                                }}
                            </span>
                            个
                        </div>
                        <div class="school-type">
                            {{
                                schoolInfo.schoolSecurityInformation[1]
                                    .equipment
                            }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="key-file-item">
                <div class="key-file-item-centen">
                    <img src="@/assets/img/schoolBaseInfo/path-icon.png" alt="" />
                    <div class="key-file-item-info">
                        <div class="school-number">
                            <span style="font-size:20px">
                                {{
                                    schoolInfo.schoolSecurityInformation[2]
                                        .sum || '0'
                                }}
                            </span>
                            个
                        </div>
                        <div class="school-type">
                            {{
                                schoolInfo.schoolSecurityInformation[2]
                                    .equipment
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="noData">
            暂无数据
        </div>
    </div>
</template>
<script>
import videoPie from './videoPie'
export default {
    name: 'schoolBaseInfo',
    props: {
        schoolId: {
            type: String,
            default: {
                return: '',
            },
        },
    },
    data() {
        return {
            schoolInfo: {},
            numTotal: 0,
            schoolType: [
                { name: '幼儿园', value: 0 },
                { name: '小学', value: 1 },
                { name: '初中', value: 2 },
                { name: '高中', value: 3 },
                { name: '完全中学', value: 4 },
                { name: '九年一贯制学校', value: 5 },
                { name: '九年一贯制高中', value: 6 },
                { name: '大学', value: 7 },
                { name: '职业学校', value: 8 },
                { name: '中等专业学校', value: 9 },
                { name: '技工学校', value: 10 },
                { name: '其他', value: 11 },
            ],
            workType: [
                { name: '公办', value: 0 },
                { name: '集体办', value: 1 },
                { name: '民办', value: 2 },
                { name: '其他', value: 3 },
            ],
        }
    },
    mounted() {},
    methods: {
        async getInfo(val) {
            let req = { schoolId: parseInt(val) }
            let self = this
            let res = await self.$Http.getSchoolDetailsCopy(req)
            if (res.code == 200) {
                if (res.data) {
                    self.schoolInfo = res.data[0] || {}
                    self.schoolInfo.basicInformationOfTheSchool[0].schoolTypeName = self.getSchoolTypeName(
                        self.schoolInfo.basicInformationOfTheSchool[0]
                            .schoolCategory,
                        self.schoolType
                    )
                    self.schoolInfo.basicInformationOfTheSchool[0].workTypeName = self.getSchoolTypeName(
                        self.schoolInfo.basicInformationOfTheSchool[0]
                            .workCategory,
                        self.workType
                    )
                    self.schoolInfo.numberOfFilesReported = self.schoolInfo.numberOfFilesReported.map(
                        (item) => {
                            if (item.file == 'canteenFile') {
                                item.alarmType = '食堂档案'
                            } else if (item.file == 'securityFile') {
                                item.alarmType = '安保档案'
                            } else if (item.file == 'schoolBusFile') {
                                item.alarmType = '校车档案'
                            } else if (item.file == 'deviceFile') {
                                item.alarmType = '器械档案'
                            } else if (item.file == 'fireFile') {
                                item.alarmType = '消防档案'
                            }
                            return item
                        }
                    )
                    self.numTotal = self.sum(
                        self.schoolInfo.numberOfFilesReported
                    )
                }
            } else if (res.code == 101) {
            } else {
            }
        },
        // 计算总的档案上报数
        sum(arr) {
            var s = 0
            for (var i = arr.length - 1; i >= 0; i--) {
                s += arr[i].sum
            }
            return s
        },
        getSchoolTypeName(val, list) {
            let a = list.find((item) => {
                return item.value == val
            })
            return a.name || ''
        },
    },
    components: {
        videoPie,
    },
    watch: {
        schoolId: {
            handler(newName, oldName) {
                this.getInfo(newName)
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>
<style scoped lang="scss">
.school-info {
    display: flex;
    flex-direction: row;
    height: 30px;
    margin-top: 5px;
    .school-info-icon {
        margin-left: 10px;
        width: 2px;
        height: 20px;
        margin-top: 5px;
        background-color: #3f8fbc;
    }
    .school-info-title {
        line-height: 30px;
        color: #ace1ff;
        font-size: 16px;
        margin-left: 10px;
    }
}
.table-List-bg {
    align-items: center;
    height: 36px;
    text-align: center;
    color: #c4f0ff;
    line-height: 36px;
    font-size: 18px;
    background-image: linear-gradient(
        to left,
        rgba(143, 149, 255, 0),
        rgba(63, 120, 188, 1),
        rgba(143, 149, 255, 0)
    );
    border-radius: 4px;
    margin-top: 20px;
    margin-left: 90px;
    width: 212px;
}
.table-list-conten {
    width: calc(100% - 90px);
    height: 250px;
    margin-left: 15px;
    margin-top: 10px;
    overflow: scroll;
}
.table-item {
    height: 40px;
    display: flex;
    flex-direction: row;
    .item-left {
        width: 80px;
        height: 40px;
        line-height: 40px;
        margin-left: 26px;
        text-align: center;
        img {
            width: 28px;
            height: 30px;
        }
    }
    .item-right {
        width: 100%;
        .item-right-top {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: 40px;
            .span-one {
                width: 50%;
                text-align: left;
                font-size: 16;
                color: #d7deff;
                margin-top: 20px;
            }
            .span-two {
                width: 50%;
                text-align: right;
                font-size: 16;
                color: #d7deff;
                margin-top: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                // white-space: nowrap;
            }
        }
        .item-right-bottom {
            height: 1px;
            background-image: linear-gradient(
                to left,
                rgba(129, 134, 213, 0),
                rgba(63, 120, 188, 1),
                rgba(4, 78, 1715, 0)
            );
        }
    }
}
.manage-structure {
    display: flex;
    margin-left: 4%;
    .principal-list {
        width: 30%;
        display: flex;
        flex-direction: column;
        .principal-list-item {
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: #ace1ff;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }
    img {
        width: 13px;
    }
}
.noData {
    text-align: center;
    height: 44px;
    line-height: 44px;
    width: 100%;
    overflow: hidden;
    color: white;
    margin-bottom: 10px;
}
.key-file-item {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    .key-file-item-centen {
        margin-left: 4%;
        width: 44%;
        height: 70px;
        color: #b2e3ff;
        background: url('~@/assets/img/schoolBaseInfo/school-info-bg.png') center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: row;
        img {
            margin-left: 5px;
            margin-top: 10px;
            height: 50px;
            width: 50px;
        }
        .key-file-item-info {
            display: flex;
            flex-direction: column;
            text-align: center;
            .school-number {
                font-size: 14px;
                height: 28px;
                margin-top: 10px;
                margin-left: 10px;
            }
            .school-type {
                height: 20px;
                font-size: 14px;
                margin-left: 10px;
                margin-top: 5px;
            }
        }
    }
}
.school-info-detail {
    margin: 5px 4%;
    box-shadow: 1px 1px 10px 6px#3F78BC inset;
    background-size: 100% 100%;
    .file-num-total {
        width: 50%;
        text-align: center;
        padding-top: 12px;
        height: 22px;
        font-size: 12px;
        color: #ace1ff;
    }
}
</style>
